module.exports = __webpack_public_path__ + "img/lock.50e56548.png";